__turbopack_context__.v({
  "alignEnd": "popover-module__0E79Uq__alignEnd",
  "alignStart": "popover-module__0E79Uq__alignStart",
  "anchor": "popover-module__0E79Uq__anchor",
  "isDanger": "popover-module__0E79Uq__isDanger",
  "menuItem": "popover-module__0E79Uq__menuItem",
  "menuLead": "popover-module__0E79Uq__menuLead",
  "menuSectionLabel": "popover-module__0E79Uq__menuSectionLabel",
  "menuSep": "popover-module__0E79Uq__menuSep",
  "menuText": "popover-module__0E79Uq__menuText",
  "menuTrail": "popover-module__0E79Uq__menuTrail",
  "mobileSheet": "popover-module__0E79Uq__mobileSheet",
  "panel": "popover-module__0E79Uq__panel",
  "rise": "popover-module__0E79Uq__rise",
  "scrim": "popover-module__0E79Uq__scrim",
  "scrimMobileOnly": "popover-module__0E79Uq__scrimMobileOnly",
  "slotBody": "popover-module__0E79Uq__slotBody",
  "slotFooter": "popover-module__0E79Uq__slotFooter",
  "slotHeader": "popover-module__0E79Uq__slotHeader",
  "slotted": "popover-module__0E79Uq__slotted",
});
